import React from "react";
import slider1 from "../../../assets/images/slider/slider-1.jpg";
import slider2 from "../../../assets/images/slider/slider-2.jpg";
import slider3 from "../../../assets/images/slider/slider-3.jpg";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./Slider.css";

const Slider = () => {
  return (
    <section
      className="mt-md-2 m-slider"
      data-aos="fade-left"
      data-aos-duration="2500"
    >
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner rounded slider-overlay">
          <div className="carousel-item active">
            {/* <LazyLoadImage
              src={slider1}
              alt="slider-img-1"
              className="d-block carousel-img"
              placeholderSrc={slider1}
              effect="blur"
              style={{ cursor: "pointer" }}
            /> */}

            <img
              className="d-block carousel-img"
              src={slider1}
              alt="slider-img-1"
            />

            <div className="carousel-caption d-flex align-items-center justify-content-center h-100 car-cap">
              <div className="w-75">
                <h1 className="fw-semibold mb-3 lh-sm fs-slider-h1">
                  Online Food Delivery
                  <br className="lh-slider" />
                  To Your Home
                </h1>
                <p className="fw-lighter lh-tab lh-mob">
                  <small>
                    Online Food Delivery is the process whereby the food that
                    was ordered online is prepared and delivered to the
                    customer. My Food For You website is the best one to fulfill
                    your aspects.
                  </small>
                </p>
                <div>
                  <button className="btn btn-sm btn-primary bg-gradient px-md-3 px-lg-4 py-md-2 mt-2 rounded-2">
                    <Link to="/services" className="btn-order">
                      <span className="fs-btn">See My Services</span>
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            {/* <LazyLoadImage
              src={slider2}
              alt="slider-img-2"
              className="d-block carousel-img"
              placeholderSrc={slider2}
              effect="blur"
              style={{ cursor: "pointer" }}
            /> */}

            <img
              className="d-block carousel-img"
              src={slider2}
              alt="slider-img-2"
            />

            <div className="carousel-caption d-flex align-items-center justify-content-center h-100 car-cap">
              <div className="w-75">
                <h1 className="fw-semibold mb-3 lh-sm fs-slider-h1">
                  Online Food Delivery
                  <br className="lh-slider" />
                  To Your Home
                </h1>
                <p className="fw-lighter lh-tab lh-mob">
                  <small>
                    Online Food Delivery is the process whereby the food that
                    was ordered online is prepared and delivered to the
                    customer. My Food For You website is the best one to fulfill
                    your aspects.
                  </small>
                </p>
                <div>
                  <button className="btn btn-sm btn-primary bg-gradient px-md-3 px-lg-4 py-md-2 mt-2 rounded-2">
                    <Link to="/services" className="btn-order">
                      <span className="fs-btn">See My Services</span>
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            {/* <LazyLoadImage
              src={slider3}
              alt="slider-img-3"
              className="d-block carousel-img"
              placeholderSrc={slider3}
              effect="blur"
              style={{ cursor: "pointer" }}
            /> */}
            <img
              className="d-block carousel-img"
              src={slider3}
              alt="slider-img-3"
            />

            <div className="carousel-caption d-flex align-items-center justify-content-center h-100 car-cap">
              <div className="w-75">
                <h1 className="fw-semibold mb-3 lh-sm fs-slider-h1">
                  Online Food Delivery
                  <br className="lh-slider" />
                  To Your Home
                </h1>
                <p className="fw-lighter lh-tab lh-mob">
                  <small>
                    Online Food Delivery is the process whereby the food that
                    was ordered online is prepared and delivered to the
                    customer. My Food For You website is the best one to fulfill
                    your aspects.
                  </small>
                </p>
                <div>
                  <button className="btn btn-sm btn-primary bg-gradient px-md-3 px-lg-4 py-md-2 mt-2 rounded-2">
                    <Link to="/services" className="btn-order">
                      <span className="fs-btn">See My Services</span>
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon w-slider-arrow h-25"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon w-slider-arrow h-25"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default Slider;
